/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One round's board-standing decomposition: source (karma, serial-existing, serial-new, quiz, wheel, qr-minelab, qr-club, follow, post, like, referral) → that source's capped contribution to the round's board total.
 * @export
 * @interface RttrBoardBreakdownRoundMap
 */
export interface RttrBoardBreakdownRoundMap {
    [key: string]: number;
}

/**
 * Check if a given object implements the RttrBoardBreakdownRoundMap interface.
 */
export function instanceOfRttrBoardBreakdownRoundMap(value: object): value is RttrBoardBreakdownRoundMap {
    return true;
}

export function RttrBoardBreakdownRoundMapFromJSON(json: any): RttrBoardBreakdownRoundMap {
    return RttrBoardBreakdownRoundMapFromJSONTyped(json, false);
}

export function RttrBoardBreakdownRoundMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrBoardBreakdownRoundMap {
    return json;
}

export function RttrBoardBreakdownRoundMapToJSON(json: any): RttrBoardBreakdownRoundMap {
    return RttrBoardBreakdownRoundMapToJSONTyped(json, false);
}

export function RttrBoardBreakdownRoundMapToJSONTyped(value?: RttrBoardBreakdownRoundMap | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

